import SearchParams from '../Elements/SearchParams';
import ExportQueueSearchParams from '../Contents/Operations/PaymentExport/AllExport/ExportQueueSearchParams';
import ExportQueueItem from '../Domain/ExportQueueItem.js';
import AuthService from './authService.js';

export default class ExportQueueService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, ExportQueueSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/ExportQueue/GetBySearchParams/?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    let mappedItems = [];

    if (itemlist !== null) {
      mappedItems = itemlist.map((item) => new ExportQueueItem(item));
    }

    return mappedItems;
  }

  static GetById(id) {
    let authService = AuthService.getInstance();
    let url = '/api/ExportQueue/GetById/' + id + '?clearCache=false';
    return authService.CallBackendFunction(url);
  }

  static StartEndOfMonthExport(item) {
    let authService = AuthService.getInstance();
    let itemJson = JSON.stringify(item);
    //let url = '/api/ExportQueue/StartEndOfMonthExport/';
    let url = '/api/TpPaymentExport/ExecutePaymentExport/';
    return authService.CallBackendFunctionPost(url, itemJson);
  }

  static StartAdHocExport(item) {
    let authService = AuthService.getInstance();
    let itemJson = JSON.stringify(item);
    //let url = '/api/ExportQueue/StartAdHocExport/';
    let url = '/api/TpPaymentExport/ExecutePaymentExport/';
    return authService.CallBackendFunctionPost(url, itemJson);
  }
}
